import { createLazyFileRoute } from '@tanstack/react-router';

import { DefaultLayout } from '@src/layout';
import { IndustryDetail } from '@src/pages/Industries';

export const Route = createLazyFileRoute('/industries/retail')({
  component: RetailIndustryPage,
});

function RetailIndustryPage() {
  return (
    <DefaultLayout>
      <IndustryDetail industryId="retail" />
    </DefaultLayout>
  );
}
